import { getTitleStyle } from '../../../../block/block.style';
import { makeDefaultStylingContext } from '../../../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const titleStyle = getTitleStyle(context);

  return {
    Title: {
      h: titleStyle.text.lineHeight,
      w: 600,
    },
    Items: {},
  };
};
